export default __webpack_public_path__ + "static/media/charge.621672f2.png";